import type { FunctionComponent } from 'react';

import { Error, Field, FormTheme } from '@kanda-libs/ks-component-ts';
import { Text } from '@kanda-libs/ks-design-library';

import { FIELD_NAMES } from 'pages/Quote/constants';

import useBorrowAmount from './useBorrowAmount';

import { DepositLimits, formatter } from '../../../helpers';

interface BorrowAmountProps {
  isLoading: boolean;
  depositLimits: DepositLimits;
  min: string;
  max: string;
  creditLine: number;
}

const BorrowAmount: FunctionComponent<BorrowAmountProps> = function ({
  isLoading,
  depositLimits,
  min,
  max,
  creditLine,
}) {
  const { error, validation, classNames, onBlur } = useBorrowAmount(
    depositLimits,
    min,
    max,
    creditLine,
  );

  return (
    <div className={classNames.container}>
      <div className={classNames.input}>
        <Text
          text="Borrow amount"
          className={classNames.heading}
          isLoading={isLoading}
        />
        <Field.Validator validation={validation}>
          <div className={classNames.fieldWrapper}>
            <div className={classNames.field}>
              <FormTheme variant="streamline">
                <Field.NumberInput
                  type="price"
                  name={FIELD_NAMES.editLoanAmount}
                  id={FIELD_NAMES.editLoanAmount}
                  onBlur={onBlur}
                  className={error ? 'border border-red-200 rounded-md' : ''}
                />
              </FormTheme>
            </div>
          </div>
        </Field.Validator>
      </div>
      {error && (
        <div className="mb-2">
          <Error error={error} />
        </div>
      )}
      <Field.RangeInput
        name={FIELD_NAMES.loanAmount}
        min={min}
        max={max}
        formatter={formatter}
        isLoading={isLoading}
        showCurrentValueLabel={false}
      />
    </div>
  );
};

export default BorrowAmount;
